import axios from '@/utils/axios'
import { AxiosPromise } from 'axios'

/**
 * Profile request
 *
 * @param params
 */
export const index = (params = {}): AxiosPromise => {
  return axios.get('/original_dramas', { params })
}

export const show = (id: number, params = {}): AxiosPromise => {
  return axios.get(`/original_dramas/${id}`, { params })
}

/**
 *
 * @param params
 */
export const store = (params = {}): AxiosPromise => {
  return axios.post('/original_dramas', params)
}

/**
 *
 * @param id
 * @param params
 */
export const update = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/original_dramas/${id}`, params)
}

export const approved = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/original_dramas/${id}/approved`, params)
}

/**
 * Update attribute
 *
 * @param id
 * @param params
 */
export const updateAttribute = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/original_dramas/${id}/attribute`, params)
}

/**
 * @param id
 */
export const destroy = (id: number): AxiosPromise => {
  return axios.delete(`/original_dramas/${id}`)
}
